import { Declaration } from 'modules/domain/types'
import { FC } from 'react'
import styled from 'styled-components'
import { Card } from 'views/components/Card/Card'
import { BuyerFinStatus } from './BuyerFinStatus'
import { WhMovementsBlock } from './BidDetailBlock/WhMovementsBlock/WhMovementsBlock'
import { Bids } from './Bids/Bids'
import { DealDetailBlock } from './DealDetailBlock/DealDetailBlock'
import { DealExecutorsBlock } from './DealExecutorsBlock/DealExecutorsBlock'
import { DocumentRequestControl } from './DocumentRequestControl/DocumentRequestControl'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`

interface DealEditProps {
  declaration: Declaration | undefined
}

export const DealDetailContent: FC<DealEditProps> = ({ declaration }) => {
  return (
    <Card.Container>
      <ContentWrapper>
        <DealExecutorsBlock />
        <DealDetailBlock />
        <BuyerFinStatus />
        <DocumentRequestControl declaration={declaration} />
        <WhMovementsBlock />
        <Bids />
      </ContentWrapper>
    </Card.Container>
  )
}
